import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import TourDetail from "../pages/tour-detail/page";
import Transfers from "../pages/transfers/page";
import HurghadaTours from "../pages/hurghada-tours/page";
import MarsaAlamTours from "../pages/marsa-alam-tours/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ausfluege-hurghada",
    element: <HurghadaTours />,
  },
  {
    path: "/ausfluege-marsa-alam",
    element: <MarsaAlamTours />,
  },
  {
    path: "/tour/:id",
    element: <TourDetail />,
  },
  {
    path: "/transfers",
    element: <Transfers />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;